import React from 'react';

import TuvCertificate from 'assets/images/tuv-certificate.png';
import PharmuniCertificate from 'assets/images/pharmuni-certificate.png';
import LikeIcon from 'assets/icons/like.svg';
import PersonalCardIcon from 'assets/icons/personalcard.svg';

import classes from './CourseCertificate.module.scss';
import TuvCertificateMessage from '@core/components/tuvcertificatemessage/TuvCertificateMessage';

const CourseCertificate = () => {
    return (
        <div className={classes['wrapper']}>
            <div className='row'>
                <div className='col-md-6 col-12'>
                    <img src={PharmuniCertificate.src} alt='TUV Certificate' />
                    <TuvCertificateMessage />
                </div>
                <div className='col-md-6 col-12 mt-4 mt-md-0'>
                    <span className={classes['completion']}>Completion with </span>
                    <h3>Pharmuni Certificate</h3>
                    <div className={classes['issued']}>Certificates issued by </div>
                    <h4 className={classes['zamann']}><a href='https://zamann-pharma.com/'>Zamann Pharma Support GmbH</a></h4>
                    <div className={classes['tuv']}>a TÜV-certified company in</div>
                    <div className='d-flex flex-wrap align-items-center gap-2 mt-4'>
                        <LikeIcon />
                        <p>
                            Personnel qualification in the field of pharmacy,
                            medical technology and quality assurance.
                        </p>
                    </div>
                    <div className='d-flex flex-wrap align-items-center gap-2 mt-3'>
                        <PersonalCardIcon />
                        <p>
                            Consulting service in the field of pharmacy,
                            medical technology and quality assurance.
                        </p>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default CourseCertificate;